//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AccountCode',
  props: {
    length: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      // 验证码
      code: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.code = [];
      for (let i = 0; i < Number(this.length); i += 1) {
        this.code.push('');
      }
      const timer = setTimeout(() => {
        this.controlFocus();
        clearTimeout(timer);
      }, 10);
    },
    // focus事件和input事件都自动更新当前选中的格子
    controlFocus() {
      let aim = 'input';
      // 自动搜索第一个未填满的空格并focus
      for (let i = 0; i < this.code.length; i += 1) {
        if (this.code[i] === '') {
          aim += i.toString();
          break;
        }
      }

      // 所有空格都填满了 指向最后一个
      if (aim === 'input') {
        aim = `input${this.code.length - 1}`;
      }
      this.$refs[aim][0].focus();
    },
    input() {
      this.$emit('change', this.code.join(''));
      this.controlFocus();
    },
    deleteFocus() {
      // 已经全部填满 删除最后一个
      if (this.code[this.code.length - 1] !== '') {
        this.code[this.code.length - 1] = '';
        this.$forceUpdate();
        this.input();
      } else {
        // 寻找最后一个被填满的空格清空它
        for (let i = 0; i < this.code.length; i += 1) {
          if (this.code[i] === '') {
            if (i !== 0) {
              this.code[i - 1] = '';
              this.$forceUpdate();
              this.input();
            }
            break;
          }
        }
      }
    },
    submitCode() {
      const lengths = this.length;
      let validateNum = 0;
      for (let i = 0; i < this.code.length; i += 1) {
        if (this.code[i] !== '') {
          validateNum += 1;
        }
      }
      if (validateNum === Number(lengths)) {
        this.$emit('doSubmit');
      }
    },
  },
};
